import { TaggingRuleActionType } from './enums'

export const ACTION_TYPE_TITLE = {
  [TaggingRuleActionType.ADD_TAG]: 'Add tags',
  [TaggingRuleActionType.SET_CATEGORY]: 'Set Category',
  [TaggingRuleActionType.SET_SUB_CATEGORY]: 'Set Subcategory',
  [TaggingRuleActionType.SET_COUNTERPARTY]: 'Set Counterparty',
  [TaggingRuleActionType.SET_OVERRIDE_DESCRIPTION]: 'Set Override Description',
  [TaggingRuleActionType.SET_SIGN]: 'Set Sign',
}

// The transaction column each action writes. Null means the action has no single column to diff
// against in the rule preview (tags are a relation; sign rewrites the amount's sign).
export const ACTION_TYPE_FIELD: Record<TaggingRuleActionType, string | null> = {
  [TaggingRuleActionType.ADD_TAG]: null,
  [TaggingRuleActionType.SET_CATEGORY]: 'category',
  [TaggingRuleActionType.SET_SUB_CATEGORY]: 'subcategory',
  [TaggingRuleActionType.SET_COUNTERPARTY]: 'counterparty',
  [TaggingRuleActionType.SET_OVERRIDE_DESCRIPTION]: 'override_description',
  [TaggingRuleActionType.SET_SIGN]: null,
}
